import { FuelTypography } from '@frete.com/fuel-react'
import * as Styled from './styled'
import { ReactComponent as SignOut } from '~assets/images/svgs/sign-out.svg'
import { ReactComponent as GooglePlay } from '~assets/images/svgs/google-play.svg'
import { ReactComponent as Desktop } from '~assets/images/svgs/desktop.svg'
import { ReactComponent as Truck } from '~assets/images/svgs/truck.svg'
import { ReactComponent as DialogueBalloon } from '~assets/images/svgs/dialogue-balloon.svg'
import { ReactComponent as StarsEmote } from '~assets/images/svgs/stars-emote.svg'
import { ReactComponent as Box } from '~assets/images/svgs/box.svg'
import { ReactComponent as Telephone } from '~assets/images/svgs/telephone.svg'
import { Props } from './types'
import { useLocation, useNavigate } from 'react-router-dom'
import { usePath, useStore } from '~hooks'

function MobileMenuOptions({ isVisible, username, onClose, onClickLogout }: Props) {
  const location = useLocation()
  const navigate = useNavigate()
  const store = useStore()
  const path = usePath()

  function handleClickFreights() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({ saveVehicleDataModal: true, saveVehicleDataCallback: () => (window.location.href = '/fretes') })
    else window.location.href = '/fretes'
  }

  function handleClickEvaluation() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: () => (window.location.href = '/avaliacoes'),
      })
    else window.location.href = '/avaliacoes'
  }

  function handleClickAttendance() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: () => (window.location.href = '/ajuda-e-atendimento'),
      })
    else window.location.href = '/ajuda-e-atendimento'
  }

  function handleClickVehicleData() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: () => navigate('/dados-veiculo', { state: { previousPath: path } }),
      })
    else navigate('/dados-veiculo', { state: { previousPath: path } })
  }

  function handleClickContactNumbers() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: () => navigate('/numeros-contato', { state: { previousPath: path } }),
      })
    else navigate('/numeros-contato', { state: { previousPath: path } })
  }

  function handleClickDesktopVersion() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: () =>
          window.open('https://www.fretebras.com.br/fretes/', '_blank', 'noopener noreferrer').focus(),
      })
    else window.open('https://www.fretebras.com.br/fretes/', '_blank', 'noopener noreferrer').focus()
  }

  function handleClickDownloadApp() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: () =>
          window
            .open(
              'https://play.google.com/store/apps/details?id=br.lgfelicio&referrer=utm_source%3Drodape-fretebras%26utm_medium%3Dbanner%26utm_campaign%3Drodape-checkin-android',
              '_blank',
              'noopener noreferrer',
            )
            .focus(),
      })
    else
      window
        .open(
          'https://play.google.com/store/apps/details?id=br.lgfelicio&referrer=utm_source%3Drodape-fretebras%26utm_medium%3Dbanner%26utm_campaign%3Drodape-checkin-android',
          '_blank',
          'noopener noreferrer',
        )
        .focus()
  }

  return (
    <Styled.Container data-testid="mobile-menu" $isVisible={isVisible}>
      <Styled.Header>
        <Styled.HeaderUser />
        <FuelTypography size="body-md" weight="bold">
          Olá, {username}
        </FuelTypography>
        <Styled.Close onClick={onClose} />
      </Styled.Header>
      <Styled.Division>
        <FuelTypography size="overline" weight="bold" color="neutral-default">
          PARA O CAMINHONEIRO
        </FuelTypography>
      </Styled.Division>
      <Styled.Option onClick={handleClickFreights}>
        <Box />
        Fretes
      </Styled.Option>
      <Styled.Option onClick={handleClickEvaluation}>
        <StarsEmote />
        Avaliações
      </Styled.Option>
      <Styled.Division>
        <FuelTypography size="overline" weight="bold" color="neutral-default">
          CONTATO FRETEBRAS
        </FuelTypography>
      </Styled.Division>
      <Styled.Option onClick={handleClickAttendance}>
        <DialogueBalloon />
        Atendimento
      </Styled.Option>
      <Styled.Division>
        <FuelTypography size="overline" weight="bold" color="neutral-default">
          CONFIGURAÇÃO DE CONTA
        </FuelTypography>
      </Styled.Division>
      <Styled.Option onClick={handleClickVehicleData}>
        <Truck />
        Dados do veículo
      </Styled.Option>
      <Styled.Option onClick={handleClickContactNumbers}>
        <Telephone />
        Números de contato
      </Styled.Option>
      <Styled.Division />
      <Styled.Option onClick={handleClickDesktopVersion}>
        <Desktop />
        Ir para versão computador
      </Styled.Option>
      <Styled.Option onClick={handleClickDownloadApp}>
        <GooglePlay />
        Fazer download do App
      </Styled.Option>
      <Styled.Option onClick={onClickLogout}>
        <SignOut />
        Sair da conta
      </Styled.Option>
    </Styled.Container>
  )
}

export default MobileMenuOptions
